import axios from 'axios';
import { getBackendURL } from '../../Utils/ServerURL';
import { STARTING_TABLE_PAGE, DEFAULT_ROWS_PER_PAGE, ORDER_BY_BRAND, ORDER_ASCENDING } from '../../Utils/Constants';
const sControllerEndpoint = 'Optionals';


export class AdminOptionalAPI {

  getAdminTableData(page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = ORDER_BY_BRAND, order = ORDER_ASCENDING, searchBy = '') {
    let params = {
      page: page,
      rowsPerPage: rowsPerPage,
      orderBy: orderBy,
      order: order
    }
    if (searchBy)
      params.searchBy = searchBy;
    return axios.get(getBackendURL() + sControllerEndpoint + '/GetDataForTable', { params });
  }

  saveNewElement(dto) {
    return axios.post(getBackendURL() + sControllerEndpoint, dto);
  }

  saveEditElement(dto) {
    return axios.put(getBackendURL() + sControllerEndpoint, dto);
  }

}

export default AdminOptionalAPI


// WEBPACK FOOTER //
// ./src/API/Admin/AdminOptionalAPI.js